import React from "react";

interface CheckmarkProps {
  fill: string;
}

const ColoredCheckmark = ({ fill }: CheckmarkProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.119 8.193a.838.838 0 0 0-.59.27c-.22.232-1.765 1.899-3.35 3.607-1.336 1.44-2.342 2.52-2.809 3.022L7.38 12.7a.825.825 0 0 0-.635-.177.85.85 0 0 0-.568.347.935.935 0 0 0-.168.667.91.91 0 0 0 .333.596l3.596 2.877c.34.272.82.238 1.124-.08.221-.232 1.766-1.898 3.35-3.606s3.207-3.458 3.328-3.585a.932.932 0 0 0 .194-.996.855.855 0 0 0-.814-.55Z"
        fill={fill}
      />
    </svg>
  );
};

export default ColoredCheckmark;
